import CodeIcon from '@mui/icons-material/Code';
import {Box, Fab} from '@mui/material';
import {array, func, number, object, oneOfType} from 'prop-types';
import React, {useRef} from 'react';

const SliderLine = React.forwardRef((props, ref) => (
  <Box
    ref={ref}
    {...props}
    sx={[
      {
        left: '50%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        position: 'absolute',
        top: 0,
        zIndex: 0,
        transform: 'translateX(-50%)',

        '&:before,&:after': {
          content: '""',
          display: 'block',
          flexGrow: 1,
          width: 3,
          boxShadow: 1,
          backgroundColor: 'grey.100',
          position: 'relative',
          zIndex: 1,
        },
      },
      ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}
  />
));

SliderLine.propTypes = {
  sx: oneOfType([array, object]),
};

const CompareSlider = ({mapWidth, position, onChange}) => {
  const containerRef = useRef();

  const onDrag = event => {
    const clientX = event.clientX;
    const node = containerRef.current;
    if (node) {
      const rect = node.offsetParent.getBoundingClientRect();
      const position = (clientX - rect.left) / rect.width;
      const fraction = Math.max(0, Math.min(1, position));
      onChange(fraction);
    }
  };

  const onDragEnd = () => {
    document.removeEventListener('mousemove', onDrag);
    document.removeEventListener('mouseup', onDragEnd);
  };

  const onDragStart = () => {
    document.addEventListener('mousemove', onDrag);
    document.addEventListener('mouseup', onDragEnd);
  };

  return (
    <SliderLine ref={containerRef} sx={{left: mapWidth * position}}>
      <Fab
        size="small"
        color="primary"
        disableRipple
        // onMouseMove={onDrag}
        onMouseDown={onDragStart}
        sx={{
          border: '2px solid',
          borderColor: 'grey.200',
          pointerEvents: 'all',
        }}
        data-qe="compare-tool-slider-handle"
      >
        <CodeIcon fontSize="small" />
      </Fab>
    </SliderLine>
  );
};

CompareSlider.propTypes = {
  mapWidth: number,
  onChange: func,
  position: number,
};

export default CompareSlider;
